import React from 'react';
import { TabCarouselCardStoryblok } from '../../../../../../types/storyblok';
import { Box } from 'rebass';
import { StoryblokImage } from '../../../../../../base/StoryblokImage/StoryblokImage';
import Markup from '../../../../../../base/Markup/Markup';

type Props = Pick<
  TabCarouselCardStoryblok,
  'image' | 'heading' | 'description'
>;

export const TabCarouselCard = ({ image, heading, description }: Props) => (
  <Box as="div" className="flex flex-col py-9 px-4">
    <StoryblokImage
      src={image}
      mode="responsive"
      maxWidth={1000}
      alt={heading}
    />
    <Box
      as="div"
      className="!mt-10 !mb-7 [&>*]:font-foundersGrotesk [&>*]:text-p1"
    >
      <Markup content={description} />
    </Box>
  </Box>
);
